import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, withModifiers as _withModifiers, renderList as _renderList, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ca" }
const _hoisted_2 = {
  key: 0,
  class: "ca-empty"
}
const _hoisted_3 = {
  key: 1,
  class: "ca-empty",
  role: "alert"
}
const _hoisted_4 = {
  key: 3,
  class: "ca-empty",
  role: "status"
}
const _hoisted_5 = { class: "ca-kicker" }
const _hoisted_6 = { class: "ca-title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "ca-old"
}
const _hoisted_12 = {
  class: "ca-ask",
  "aria-labelledby": "ca-ask-title"
}
const _hoisted_13 = { class: "ca-ask-head" }
const _hoisted_14 = {
  key: 0,
  class: "ca-ask-thread",
  "aria-live": "polite"
}
const _hoisted_15 = { class: "ca-ask-q" }
const _hoisted_16 = {
  key: 0,
  class: "ca-ask-a"
}
const _hoisted_17 = {
  key: 0,
  class: "ca-ask-src"
}
const _hoisted_18 = {
  key: 1,
  class: "ca-ask-err",
  role: "alert"
}
const _hoisted_19 = {
  key: 2,
  class: "ca-ask-a ca-ask-wait"
}
const _hoisted_20 = {
  key: 1,
  class: "ca-ask-examples"
}
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = { class: "ca-ask-actions" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  class: "ca-tabs",
  role: "tablist"
}
const _hoisted_26 = ["aria-selected", "onClick"]
const _hoisted_27 = ["disabled", "title"]
const _hoisted_28 = {
  key: 1,
  class: "ca-download-error",
  role: "alert"
}
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "ca-h2" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 1,
  class: "ca-changes"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 0,
  class: "ca-cs"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 2,
  class: "ca-muted"
}
const _hoisted_39 = { class: "ca-summary" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { class: "ca-h2" }
const _hoisted_44 = { class: "ca-num" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { class: "ca-grid" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { class: "ca-h2" }
const _hoisted_53 = { class: "ca-num" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { key: 2 }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = { key: 3 }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = { class: "ca-h2" }
const _hoisted_64 = { class: "ca-num" }
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = { class: "ca-grid" }
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = ["innerHTML"]
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = { class: "ca-grid" }
const _hoisted_72 = ["innerHTML"]
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = { class: "ca-small" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = ["href"]
const _hoisted_78 = { class: "ca-h2" }
const _hoisted_79 = { class: "ca-num" }
const _hoisted_80 = ["innerHTML"]
const _hoisted_81 = { class: "ca-tablewrap" }
const _hoisted_82 = { class: "ca-matrix" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = ["innerHTML"]
const _hoisted_85 = ["innerHTML"]
const _hoisted_86 = { class: "ca-h2" }
const _hoisted_87 = { class: "ca-num" }
const _hoisted_88 = ["innerHTML"]
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = ["innerHTML"]
const _hoisted_91 = { class: "ca-h2" }
const _hoisted_92 = { class: "ca-num" }
const _hoisted_93 = ["innerHTML"]
const _hoisted_94 = ["innerHTML"]
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = ["innerHTML"]
const _hoisted_97 = { class: "ca-h2" }
const _hoisted_98 = { class: "ca-num" }
const _hoisted_99 = ["innerHTML"]
const _hoisted_100 = ["innerHTML"]
const _hoisted_101 = { class: "ca-tablewrap" }
const _hoisted_102 = { class: "ca-price" }
const _hoisted_103 = ["innerHTML"]
const _hoisted_104 = ["innerHTML"]
const _hoisted_105 = ["innerHTML"]
const _hoisted_106 = ["innerHTML"]
const _hoisted_107 = { class: "ca-h2" }
const _hoisted_108 = { class: "ca-num" }
const _hoisted_109 = ["innerHTML"]
const _hoisted_110 = ["innerHTML"]
const _hoisted_111 = { class: "ca-h2" }
const _hoisted_112 = { class: "ca-num" }
const _hoisted_113 = ["innerHTML"]
const _hoisted_114 = ["innerHTML"]
const _hoisted_115 = { class: "ca-h2" }
const _hoisted_116 = { class: "ca-num" }
const _hoisted_117 = ["innerHTML"]
const _hoisted_118 = ["innerHTML"]
const _hoisted_119 = { class: "ca-sources" }
const _hoisted_120 = ["href"]
const _hoisted_121 = { key: 1 }
const _hoisted_122 = ["innerHTML"]
const _hoisted_123 = { key: 4 }
const _hoisted_124 = { class: "ca-editions" }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = { class: "ca-edition-date" }
const _hoisted_127 = { class: "ca-edition-meta" }
const _hoisted_128 = { class: "ca-edition-head" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CompetitorRequests = _resolveComponent("CompetitorRequests")!
  const _component_ResearchWorkspace = _resolveComponent("ResearchWorkspace")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/ai-training",
        class: "ca-back"
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("← Back to Train AI", -1)
        ]))]),
        _: 1
      }),
      (_ctx.denied)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "This page is only available to IronBook administrators."))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadEdition(_ctx.editions[0]?.date || 'latest')))
              }, "Try latest edition")
            ]))
          : (_ctx.loaded && !_ctx.editions.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ca-empty" }, "No competitive analysis has been published yet. The first edition appears here after the weekly update runs.", -1)),
                _createVNode(_component_CompetitorRequests, {
                  "api-url": _ctx.$store.state.apiUrl
                }, null, 8, ["api-url"])
              ], 64))
            : (!_ctx.loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading competitive analysis…"))
              : (_ctx.D)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createElementVNode("a", {
                      href: "#market-research",
                      class: "ca-report-jump",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollToReport && _ctx.scrollToReport(...args)), ["prevent"]))
                    }, "Read the full research report ↓"),
                    _createVNode(_component_ResearchWorkspace, {
                      "api-url": _ctx.$store.state.apiUrl
                    }, null, 8, ["api-url"]),
                    _cache[23] || (_cache[23] = _createElementVNode("div", {
                      id: "market-research",
                      class: "ca-report-anchor"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_5, "Competitive analysis · " + _toDisplayString(_ctx.D.run.label || 'Weekly update') + " · " + _toDisplayString(_ctx.niceDate(_ctx.D.run.date)), 1),
                    _createElementVNode("h2", _hoisted_6, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.md(_ctx.D.title.before)
                      }, null, 8, _hoisted_7),
                      _cache[10] || (_cache[10] = _createTextVNode()),
                      _createElementVNode("span", {
                        class: "ca-accent",
                        innerHTML: _ctx.md(_ctx.D.title.accent)
                      }, null, 8, _hoisted_8),
                      _createElementVNode("span", {
                        innerHTML: _ctx.md(_ctx.D.title.after)
                      }, null, 8, _hoisted_9)
                    ]),
                    _createElementVNode("p", {
                      class: "ca-lede",
                      innerHTML: _ctx.md(_ctx.D.lede)
                    }, null, 8, _hoisted_10),
                    (!_ctx.isLatest)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createTextVNode("You're viewing the " + _toDisplayString(_ctx.niceDate(_ctx.D.run.date)) + " edition. ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.loadEdition(_ctx.editions[0].date)), ["prevent"]))
                          }, "Go to the latest")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("section", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[11] || (_cache[11] = _createElementVNode("h3", { id: "ca-ask-title" }, "Ask about this report", -1)),
                        _createElementVNode("p", null, "Answers come from the " + _toDisplayString(_ctx.niceDate(_ctx.D.run.date)) + " edition. Asking doesn't change the report. To have a competitor added, say \"Add <name> as a competitor\".", 1)
                      ]),
                      (_ctx.chat.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat, (t, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "ca-ask-turn"
                              }, [
                                _createElementVNode("div", _hoisted_15, _toDisplayString(t.q), 1),
                                (t.a)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createTextVNode(_toDisplayString(t.a), 1),
                                      (t.sections.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "From: " + _toDisplayString(t.sections.join(' · ')), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (t.error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(t.error), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_19, "Reading the report…"))
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.askExamples, (ex) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: ex,
                                type: "button",
                                disabled: _ctx.asking,
                                onClick: ($event: any) => (_ctx.ask(ex))
                              }, _toDisplayString(ex), 9, _hoisted_21))
                            }), 128))
                          ])),
                      _createElementVNode("form", {
                        class: "ca-ask-form",
                        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.ask()), ["prevent"]))
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", {
                          for: "ca-ask-input",
                          class: "ca-ask-label"
                        }, "Your question", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          id: "ca-ask-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.askText) = $event)),
                          rows: "2",
                          maxlength: "2000",
                          placeholder: "e.g. Which competitors have a mobile app?",
                          onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.ask()), ["exact","prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.askText]
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          (_ctx.chat.length)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "ca-ask-clear",
                                disabled: _ctx.asking,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.chat = []))
                              }, "Start over", 8, _hoisted_23))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "submit",
                            class: "ai-btn",
                            disabled: _ctx.asking || !_ctx.askText.trim()
                          }, _toDisplayString(_ctx.asking ? 'Thinking…' : 'Ask'), 9, _hoisted_24)
                        ])
                      ], 32)
                    ]),
                    _createVNode(_component_CompetitorRequests, {
                      ref: "competitors",
                      "api-url": _ctx.$store.state.apiUrl,
                      onOpenEdition: _ctx.openEdition
                    }, null, 8, ["api-url", "onOpenEdition"]),
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: t.key,
                          type: "button",
                          role: "tab",
                          "aria-selected": _ctx.tab == t.key,
                          class: _normalizeClass(["ca-tab", { 'ca-tab-on': _ctx.tab == t.key }]),
                          onClick: ($event: any) => (_ctx.tab = t.key)
                        }, _toDisplayString(t.label), 11, _hoisted_26))
                      }), 128)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ca-download",
                        disabled: _ctx.downloading,
                        title: 'Download the ' + _ctx.niceDate(_ctx.D.run.date) + ' edition as a PDF',
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.downloadPdf && _ctx.downloadPdf(...args)))
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("svg", {
                          "aria-hidden": "true",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "15",
                          height: "15",
                          viewBox: "0 0 24 24",
                          fill: "currentColor"
                        }, [
                          _createElementVNode("path", { d: "M11 2h2v11.6l4.3-4.3 1.4 1.4L12 17.4l-6.7-6.7 1.4-1.4 4.3 4.3V2zM4 19h16v2H4z" })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.downloading ? 'Making PDF…' : 'Download PDF'), 1)
                      ], 8, _hoisted_27)
                    ]),
                    (_ctx.downloadError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.downloadError), 1))
                      : _createCommentVNode("", true),
                    (_ctx.tab == 'week')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("h2", _hoisted_30, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ca-num" }, "This week", -1)),
                            _createTextVNode("What changed since " + _toDisplayString(_ctx.niceDate(_ctx.D.changes.since)), 1)
                          ]),
                          (_ctx.D.changes.intro)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                innerHTML: _ctx.md(_ctx.D.changes.intro)
                              }, null, 8, _hoisted_31))
                            : _createCommentVNode("", true),
                          (_ctx.D.changes.items && _ctx.D.changes.items.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_32, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.changes.items, (c, i) => {
                                  return (_openBlock(), _createElementBlock("li", { key: i }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["ca-kind", 'ca-kind-' + c.kind])
                                    }, _toDisplayString(_ctx.kindLabel[c.kind] || c.kind), 3),
                                    _createElementVNode("span", {
                                      class: "ca-ct",
                                      innerHTML: _ctx.md(c.title)
                                    }, null, 8, _hoisted_33),
                                    _createElementVNode("span", {
                                      class: "ca-cb",
                                      innerHTML: _ctx.md(c.body)
                                    }, null, 8, _hoisted_34),
                                    (c.sources && c.sources.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.sources, (s, j) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                                              j
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, " · "))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("a", {
                                                href: _ctx.sourceUrl(s.url),
                                                target: "_blank",
                                                rel: "noopener"
                                              }, _toDisplayString(s.title), 9, _hoisted_37)
                                            ], 64))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_38, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("em", null, "No meaningful changes found this week.", -1)
                              ]))])),
                          _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "ca-h2" }, [
                            _createElementVNode("span", { class: "ca-num" }, "Summary"),
                            _createTextVNode("The short version")
                          ], -1)),
                          _createElementVNode("ul", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.summary, (s, i) => {
                              return (_openBlock(), _createElementBlock("li", { key: i }, [
                                _createElementVNode("b", {
                                  innerHTML: _ctx.md(s.title)
                                }, null, 8, _hoisted_40),
                                _createElementVNode("span", {
                                  innerHTML: _ctx.md(s.body)
                                }, null, 8, _hoisted_41)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tab == 'full')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_43, [
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.num('ironbook')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.ironbook.heading)
                              }, null, 8, _hoisted_45)
                            ]),
                            _createElementVNode("p", {
                              innerHTML: _ctx.md(_ctx.D.ironbook.intro)
                            }, null, 8, _hoisted_46),
                            _createElementVNode("div", _hoisted_47, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.ironbook.cards, (c, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "ca-card"
                                }, [
                                  _createElementVNode("span", {
                                    class: "ca-tag",
                                    innerHTML: _ctx.md(c.tag)
                                  }, null, 8, _hoisted_48),
                                  _createElementVNode("h3", {
                                    innerHTML: _ctx.md(c.title)
                                  }, null, 8, _hoisted_49),
                                  _createElementVNode("p", null, [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.md(c.body)
                                    }, null, 8, _hoisted_50),
                                    _cache[17] || (_cache[17] = _createTextVNode()),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.status || [], (st) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: st,
                                        class: _normalizeClass(["ca-status", 'ca-st-' + st])
                                      }, _toDisplayString(st.toUpperCase()), 3))
                                    }), 128))
                                  ])
                                ]))
                              }), 128))
                            ]),
                            (_ctx.D.ironbook.callout)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "ca-callout",
                                  innerHTML: _ctx.md(_ctx.D.ironbook.callout)
                                }, null, 8, _hoisted_51))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.spotlights || [], (sp, i) => {
                            return (_openBlock(), _createElementBlock("section", {
                              key: 'sp' + i
                            }, [
                              _createElementVNode("h2", _hoisted_52, [
                                _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.num('spotlight' + i)), 1),
                                _createElementVNode("span", {
                                  innerHTML: _ctx.md(sp.title)
                                }, null, 8, _hoisted_54)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sp.blocks, (b, j) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                                  (b.p !== undefined)
                                    ? (_openBlock(), _createElementBlock("p", {
                                        key: 0,
                                        innerHTML: _ctx.md(b.p)
                                      }, null, 8, _hoisted_55))
                                    : (b.h !== undefined)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_56, [
                                          _createElementVNode("strong", {
                                            innerHTML: _ctx.md(b.h)
                                          }, null, 8, _hoisted_57)
                                        ]))
                                      : (b.ul)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_58, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b.ul, (x, k) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: k,
                                                innerHTML: _ctx.md(x)
                                              }, null, 8, _hoisted_59))
                                            }), 128))
                                          ]))
                                        : (b.ol)
                                          ? (_openBlock(), _createElementBlock("ol", _hoisted_60, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b.ol, (x, k) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                  key: k,
                                                  innerHTML: _ctx.md(x)
                                                }, null, 8, _hoisted_61))
                                              }), 128))
                                            ]))
                                          : (b.callout)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 4,
                                                class: "ca-callout",
                                                innerHTML: _ctx.md(b.callout)
                                              }, null, 8, _hoisted_62))
                                            : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          }), 128)),
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_63, [
                              _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.num('field')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.field.heading)
                              }, null, 8, _hoisted_65)
                            ]),
                            _createElementVNode("p", {
                              innerHTML: _ctx.md(_ctx.D.field.intro)
                            }, null, 8, _hoisted_66),
                            _createElementVNode("div", _hoisted_67, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.field.categories, (c, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "ca-card"
                                }, [
                                  _createElementVNode("span", {
                                    class: "ca-tag",
                                    innerHTML: _ctx.md(c.tag)
                                  }, null, 8, _hoisted_68),
                                  _createElementVNode("h3", {
                                    innerHTML: _ctx.md(c.title)
                                  }, null, 8, _hoisted_69),
                                  _createElementVNode("p", {
                                    innerHTML: _ctx.md(c.body)
                                  }, null, 8, _hoisted_70)
                                ]))
                              }), 128))
                            ]),
                            _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "ca-h3" }, "The closest competitors", -1)),
                            _createElementVNode("div", _hoisted_71, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.field.closest, (c, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "ca-card"
                                }, [
                                  _createElementVNode("span", {
                                    class: "ca-tag",
                                    innerHTML: _ctx.md(c.tag)
                                  }, null, 8, _hoisted_72),
                                  _createElementVNode("h3", {
                                    innerHTML: _ctx.md(c.name)
                                  }, null, 8, _hoisted_73),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.bullets, (b, k) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: k,
                                        innerHTML: _ctx.md(b)
                                      }, null, 8, _hoisted_74))
                                    }), 128))
                                  ]),
                                  _createElementVNode("p", _hoisted_75, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.links, (l, k) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                        k
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_76, " · "))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("a", {
                                          href: _ctx.sourceUrl(l.url),
                                          target: "_blank",
                                          rel: "noopener"
                                        }, _toDisplayString(l.title), 9, _hoisted_77)
                                      ], 64))
                                    }), 128))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_78, [
                              _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.num('matrix')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.matrix.heading)
                              }, null, 8, _hoisted_80)
                            ]),
                            _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"ca-legend\" data-v-06c8be02><span data-v-06c8be02><span class=\"ca-c ca-c-y\" data-v-06c8be02>Y</span> yes</span><span data-v-06c8be02><span class=\"ca-c ca-c-p\" data-v-06c8be02>P</span> partial / limited</span><span data-v-06c8be02><span class=\"ca-c ca-c-n\" data-v-06c8be02>N</span> no</span><span data-v-06c8be02><span class=\"ca-c ca-c-u\" data-v-06c8be02>?</span> not verified</span></div>", 1)),
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("table", _hoisted_82, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _cache[19] || (_cache[19] = _createElementVNode("th", null, "Product", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.matrix.columns, (col, i) => {
                                      return (_openBlock(), _createElementBlock("th", {
                                        key: i,
                                        innerHTML: _ctx.md(col)
                                      }, null, 8, _hoisted_83))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.matrix.rows, (r, i) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: i,
                                      class: _normalizeClass({ 'ca-ib': r.ironbook })
                                    }, [
                                      _createElementVNode("td", {
                                        innerHTML: _ctx.md(r.product)
                                      }, null, 8, _hoisted_84),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.cells, (v, j) => {
                                        return (_openBlock(), _createElementBlock("td", { key: j }, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["ca-c", 'ca-c-' + v])
                                          }, _toDisplayString(_ctx.cellLabel[v]), 3)
                                        ]))
                                      }), 128))
                                    ], 2))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _createElementVNode("p", {
                              class: "ca-small",
                              innerHTML: _ctx.md(_ctx.D.matrix.note)
                            }, null, 8, _hoisted_85)
                          ]),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['apart', 'ahead'], (key) => {
                            return _createElementVNode("section", { key: key }, [
                              _createElementVNode("h2", _hoisted_86, [
                                _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.num(key)), 1),
                                _createElementVNode("span", {
                                  innerHTML: _ctx.md(_ctx.D[key].heading)
                                }, null, 8, _hoisted_88)
                              ]),
                              (_ctx.D[key].intro)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    innerHTML: _ctx.md(_ctx.D[key].intro)
                                  }, null, 8, _hoisted_89))
                                : _createCommentVNode("", true),
                              _createElementVNode("ol", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D[key].items, (it, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: i,
                                    innerHTML: _ctx.titled(it)
                                  }, null, 8, _hoisted_90))
                                }), 128))
                              ])
                            ])
                          }), 64)),
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_91, [
                              _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.num('adding')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.adding.heading)
                              }, null, 8, _hoisted_93)
                            ]),
                            _createElementVNode("p", {
                              innerHTML: _ctx.md(_ctx.D.adding.intro)
                            }, null, 8, _hoisted_94),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.adding.tiers, (t, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: _normalizeClass(["ca-card ca-tier", 'ca-tier-' + t.tier])
                              }, [
                                _createElementVNode("span", {
                                  class: "ca-tag",
                                  innerHTML: _ctx.md(t.label)
                                }, null, 8, _hoisted_95),
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.items, (it, k) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: k,
                                      innerHTML: _ctx.titled(it)
                                    }, null, 8, _hoisted_96))
                                  }), 128))
                                ])
                              ], 2))
                            }), 128))
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_97, [
                              _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.num('pricing')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.pricing.heading)
                              }, null, 8, _hoisted_99)
                            ]),
                            _createElementVNode("p", {
                              innerHTML: _ctx.md(_ctx.D.pricing.intro)
                            }, null, 8, _hoisted_100),
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("table", _hoisted_102, [
                                _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Product"),
                                    _createElementVNode("th", null, "Price"),
                                    _createElementVNode("th", null, "Model / notes")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.pricing.rows, (r, i) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                      _createElementVNode("td", {
                                        innerHTML: _ctx.md(r.product)
                                      }, null, 8, _hoisted_103),
                                      _createElementVNode("td", {
                                        innerHTML: _ctx.md(r.price)
                                      }, null, 8, _hoisted_104),
                                      _createElementVNode("td", {
                                        innerHTML: _ctx.md(r.notes)
                                      }, null, 8, _hoisted_105)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _createElementVNode("p", {
                              innerHTML: _ctx.md(_ctx.D.pricing.outro)
                            }, null, 8, _hoisted_106)
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_107, [
                              _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.num('risks')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.risks.heading)
                              }, null, 8, _hoisted_109)
                            ]),
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.risks.items, (it, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  innerHTML: _ctx.titled(it)
                                }, null, 8, _hoisted_110))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_111, [
                              _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.num('questions')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.questions.heading)
                              }, null, 8, _hoisted_113)
                            ]),
                            _createElementVNode("ol", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.questions.items, (q, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  innerHTML: _ctx.md(q)
                                }, null, 8, _hoisted_114))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h2", _hoisted_115, [
                              _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.num('sources')), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.md(_ctx.D.sources.heading)
                              }, null, 8, _hoisted_117)
                            ]),
                            _createElementVNode("p", {
                              class: "ca-small",
                              innerHTML: _ctx.md(_ctx.D.sources.limits)
                            }, null, 8, _hoisted_118),
                            _createElementVNode("ul", _hoisted_119, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.D.sources.items, (s, i) => {
                                return (_openBlock(), _createElementBlock("li", { key: i }, [
                                  (s.url)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: _ctx.sourceUrl(s.url),
                                        target: "_blank",
                                        rel: "noopener"
                                      }, _toDisplayString(s.title), 9, _hoisted_120))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(s.title), 1))
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("p", {
                            class: "ca-footer",
                            innerHTML: _ctx.md(_ctx.D.footer)
                          }, null, 8, _hoisted_122)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tab == 'history')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                          _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "ca-h2" }, [
                            _createElementVNode("span", { class: "ca-num" }, "History"),
                            _createTextVNode("Every edition")
                          ], -1)),
                          _createElementVNode("div", _hoisted_124, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editions, (e) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: e.date,
                                type: "button",
                                class: _normalizeClass(["ca-edition", { 'ca-edition-on': e.date == _ctx.D.run.date }]),
                                onClick: ($event: any) => (_ctx.loadEdition(e.date))
                              }, [
                                _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.niceDate(e.date)), 1),
                                _createElementVNode("span", _hoisted_127, _toDisplayString(e.changes) + " change" + _toDisplayString(e.changes == 1 ? '' : 's'), 1),
                                _createElementVNode("span", _hoisted_128, _toDisplayString(e.headline), 1)
                              ], 10, _hoisted_125))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
    ])
  ], 2))
}